import React from 'react';

import InfoCardV2, { InfoCardV2Props } from '../InfoCardV2';

export type ActionCardProps = Required<
  Pick<InfoCardV2Props, 'backgroundColor' | 'text' | 'cta'>
> &
  Partial<Pick<InfoCardV2Props, 'highlightTextColor'>>;

const ActionCard = ({
  backgroundColor,
  highlightTextColor,
  text,
  cta,
}: ActionCardProps) => (
  <InfoCardV2
    backgroundColor={backgroundColor}
    highlightTextColor={highlightTextColor}
    text={text}
    cta={cta}
    desktopWidth="md"
  />
);

export default ActionCard;
